import { render } from "./UserServiceAgreement.vue?vue&type=template&id=752c8f02&scoped=true"
import script from "./UserServiceAgreement.vue?vue&type=script&lang=js"
export * from "./UserServiceAgreement.vue?vue&type=script&lang=js"

import "./UserServiceAgreement.vue?vue&type=style&index=0&id=752c8f02&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752c8f02"]])

export default __exports__